// Ponte de navegação da área administrativa (V2 espelho):
// dentro do chrome /v2 os destinos ficam em /v2/admin/...; fora dele, /admin/...
// — comportamento V1 idêntico quando a URL atual não começa com /v2.
export const adminPath = (rest = '') =>
  (window.location.pathname.startsWith('/v2') ? '/v2/admin' : '/admin') + rest

// Detalhe do pedido: dentro do chrome /v2 abre a tela V2 (mesmos dados, ações e
// permissões do OrderDetail V1); fora dele, o destino V1 de sempre.
export const orderDetailPath = orderId =>
  window.location.pathname.startsWith('/v2') ? `/v2/conta/pedidos/${orderId}` : `/admin/pedidos/${orderId}`
